import React from "react";

import CustomLink from "../CustomLink";

const NavbarDesktop = props => {
  if (!props) {
    return null;
  }
  const {data} = props;

  function findArrayElementByTag(array, tag) {
    return array.find((element) => {
      return !!(element.column && element.column === tag);
    })
  }

  function hasElementLevel3(array) {
    return array.find((element) => {
      return !!(element.menuItemsLevel3 && element.menuItemsLevel3.length  > 0);
    })
  }

  return (
    <div className="navigation">
      {data.menuItems && data.menuItems.length > 0 && (
        <ul className="navigation-items">

          {data.menuItems.filter(menuItem => !menuItem.highlight).map( (menuItem, index) => {
            const rtlClass = "";
            // (index === data.menuItems.length - 1 || index === data.menuItems.length - 2)
            //   ? "navigation-dropdown__rtl" : "";

            const twoColsClass = (menuItem.menuItemsLevel2 && menuItem.menuItemsLevel2.length > 0 && findArrayElementByTag(menuItem.menuItemsLevel2, 'right'))
              ? "navigation-dropdown__two-cols" : "";

            const hasLevel3 = (menuItem.menuItemsLevel2 && menuItem.menuItemsLevel2.length > 0 && hasElementLevel3(menuItem.menuItemsLevel2))
              ? "navigation__level2--has-level3" : "";

            return (
              <li key={menuItem.linkURL} className={(menuItem.menuItemsLevel2) ? "navigation-item navigation-item__has-level2" : "navigation-item"}>
                <CustomLink
                  linkType={menuItem.linkType}
                  linkURL={menuItem.linkURL}
                  className={(menuItem.highlight) ? "navigation-link navigation-link--btn" : "navigation-link"}
                  activeClassName="navigation-link__active"
                >
                  {menuItem.label}

                  {(menuItem.menuItemsLevel2) ? <span className="arrow-down"></span> : '' }

                </CustomLink>
                {menuItem.menuItemsLevel2 && menuItem.menuItemsLevel2.length > 0 && (
                  <div className={`navigation-dropdown ${twoColsClass} ${rtlClass}`.trim()}>

                    <div className={`navigation__level2 ${hasLevel3}`.trim()}>
                      <ul className="navigation__level2-col navigation__level2-col-1">
                        {menuItem.menuItemsLevel2.filter(item => (item.column !== 'right')).map(menuItemLevel2 => (
                            <li key={menuItemLevel2.linkURL} className={(menuItemLevel2.menuItemsLevel3) ? "navigation-item__level2 navigation-item__has-level3" : "navigation-item__level2"}>
                            <CustomLink
                              linkType={menuItemLevel2.linkType}
                              linkURL={menuItemLevel2.linkURL}
                              className="navigation-link__level2"
                            >
                              {menuItemLevel2.label}
                            </CustomLink>

                            {menuItemLevel2.menuItemsLevel3 && menuItemLevel2.menuItemsLevel3.length > 0 && (
                              <ul className="navigation__level3">
                                {menuItemLevel2.menuItemsLevel3.map(menuItemsLevel3 => (
                                  <li key={menuItemsLevel3.linkURL} className="navigation-item__level3">
                                    <CustomLink
                                      linkType={menuItemsLevel3.linkType}
                                      linkURL={menuItemsLevel3.linkURL}
                                      className="navigation-link__level3"
                                    >
                                      {menuItemsLevel3.label}
                                    </CustomLink>
                                  </li>
                                ))}
                              </ul>
                            )}
                          </li>
                        ))}
                      </ul>

                      <ul className="navigation__level2-col navigation__level2-col-2">
                        {menuItem.menuItemsLevel2.filter(item => (item.column === 'right')).map(menuItemLevel2 => (
                          <li key={menuItemLevel2.linkURL} className={(menuItemLevel2.menuItemsLevel3) ? "navigation-item__level2 navigation-item__has-level3" : "navigation-item__level2"}>
                            <CustomLink
                              linkType={menuItemLevel2.linkType}
                              linkURL={menuItemLevel2.linkURL}
                              className="navigation-link__level2"
                            >
                              {menuItemLevel2.label}
                            </CustomLink>

                            {menuItemLevel2.menuItemsLevel3 && menuItemLevel2.menuItemsLevel3.length > 0 && (
                              <ul className="navigation__level3">
                                {menuItemLevel2.menuItemsLevel3.map(menuItemsLevel3 => (
                                  <li key={menuItemsLevel3.linkURL} className="navigation-item__level3">
                                    <CustomLink
                                      linkType={menuItemsLevel3.linkType}
                                      linkURL={menuItemsLevel3.url}
                                      className="navigation-link__level3"
                                    >
                                      {menuItemsLevel3.label}
                                    </CustomLink>
                                  </li>
                                ))}
                              </ul>
                            )}
                          </li>
                        ))}
                      </ul>

                    </div>

                  </div>
                )}
              </li>
            )
          })}

          {data.menuItems.filter(menuItem => menuItem.highlight).map( (menuItem) => {
            return (
              <li key={menuItem.linkURL} className="navigation-item">
                <CustomLink
                  linkType={menuItem.linkType}
                  linkURL={menuItem.linkURL}
                  className="navigation-link navigation-link--btn"
                  activeClassName="navigation-link__active"
                >
                  {menuItem.label}
                </CustomLink>
              </li>
            )
          })}
        </ul>
      )}
    </div>
  );
};

export default NavbarDesktop;
